import React, { useState } from 'react'
import { BASE_URL } from '../../api/api';
import { useNavigate } from "react-router-dom";

const GlobalSearchhook = () => {
    const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

    const handleSearch = async () => {
        if (!searchText.trim()) return;

        try {
            const response = await fetch(`${BASE_URL}/GlobalSearchData`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ searchText }),
            });

            const data = await response.json();
            if (data && data.length > 0) {
                navigate("/global-search-result", { state: { searchResults: data } });
            } else {
                alert("No results found.");
            }
        } catch (error) {
            console.error("Search error:", error);
        }
    };
    return {
        handleSearch, searchText, setSearchText
    }
}

export default GlobalSearchhook
